import {
  string as yupString,
} from 'yup';

import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, uniqueWith } from '../../shared/forms/validators';

const schema = [
  {
    name: 'listName',
    component: SelectFormik,
    meta: { label: 'List Name', optionsKey: 'listNameOptions' },
    options: { yupType: yupString(), validationRules: [required, uniqueWith(['glAccount'], 'Combination of List Name and GL Account already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'glAccount',
    component: SelectFormik,
    meta: { label: 'GL Account', optionsKey: 'accountOptions' },
    options: { yupType: yupString(), validationRules: [required, uniqueWith(['listName'], 'Combination of List Name and GL Account already exists')] },
    additionalProps: { required: true },
  },
];

export default schema;
